import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { AppDispatch, RootState } from "../../../apis/store";
import { toGetPartners } from "../../../apis/actions/partners.actions";
import { useEffect } from "react";
import { FaArrowRightLong } from "react-icons/fa6";

import { HOME_WOW_DURATION, homeWowDelay } from "../../../utils/homeWow";

const Brands = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const { list } = useSelector((state: RootState) => state.partners.partners);

  useEffect(() => {
    dispatch(toGetPartners(i18n.language));
  }, [dispatch, i18n.language]);

  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    slidesToShow: 6,
    slidesToScroll: 3,
    autoplay: true,
    speed: 5000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  return (
    <section className="py-96 ac-home-partners">
      <div className="ac-home-partners__inner ac--font-expo">
        <div className="container">
          <div className="box-search-category ac-home-partners__box">
            <h3
              className="heading-3 mb-0 neutral-1000 wow fadeInUp ac-home-partners__heading ac--font-expo"
              data-wow-duration={HOME_WOW_DURATION}
              data-wow-delay={homeWowDelay(0)}
            >
              {t("home.brands.title")}
            </h3>
            <div className="ac-home-partners__toolbar">
              <p
                className="text-lg-medium neutral-500 wow fadeInUp ac-home-partners__subtitle ac--font-expo"
                data-wow-duration={HOME_WOW_DURATION}
                data-wow-delay={homeWowDelay(1)}
              >
                {t("home.brands.subtitle")}
              </p>
              <Link
                to="/our-partners"
                className="wow fadeInUp ac-home-partners__cta"
                data-wow-duration={HOME_WOW_DURATION}
                data-wow-delay={homeWowDelay(2)}
              >
                {t("home.brands.next")}
                <FaArrowRightLong
                  className="ac-home-partners__cta-icon ac-home-partners__cta-icon--forward"
                  aria-hidden
                />
              </Link>
            </div>
            <div className="carouselTicker carouselTicker-left box-list-brand-car ac-home-partners__track flex-lg-nowrap justify-content-lg-between gap-3 justify-content-center">
              <div className="slider-container">
                {/*
                  Isolate from html[dir=rtl]: slick + RTL breaks track width and causes
                  horizontal page scroll on mobile (same pattern as hero).
                */}
                <div className="ac-home-partners__slider-mount">
                  <Slider {...settings} className="ac-home-partners__slider">
                    {list &&
                      list.map((el: any, i: number) => (
                        <div key={el.id ?? i} className="ac-home-partners__slide">
                          <div className="item-brand-2 ac-home-partners__brand">
                            <img
                              src={el.image_1920}
                              alt=""
                              loading="lazy"
                            />
                          </div>
                        </div>
                      ))}
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Brands;
